<template>
  <div class="blog-item m-b-50">
    <BlogItemHeader
      :blog="blog"
    />
    <div
      class="blog-description"
    >
      <p>
        {{ blog.text }}
      </p>
      <div class="d-flex justify-content-end">
        <router-link
          class="card-ctx text-primary font-weight-bold l-h-20"
          :to="{
            name: R_BLOG_DETAILS,
            query: {id: blog.id}
          }"
        >
          Continue Reading
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import BlogItemHeader from '@/components/Blog/BlogItemHeader';
import { R_BLOG_DETAILS } from '@/router/routes';

export default {
  name: 'BlogCard',
  components: {
    BlogItemHeader,
  },
  props: {
    showShortDetails: {
      type: Boolean,
      default: false,
    },
    blog: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      R_BLOG_DETAILS,
    };
  },
};
</script>
